import React, { useState, useEffect } from 'react'
import RainbowGauge from './RainbowGauge'
import {observer} from 'mobx-react'
import {store} from '../../stores/store'

import IndicatorsPool from '../../js/IndicatorsPool'
import ParametersPool from '../../js/ParametersPool'
import PopupStore, { POPUPS_IDS } from '../../stores/PopupStore'


function UIJauge() {

  let sustainability = IndicatorsPool.getIndicatorValue("indT43")
  let eco = IndicatorsPool.getIndicatorValue("indT42")
  let social = IndicatorsPool.getIndicatorValue("indT37")
  let environmental = IndicatorsPool.getIndicatorValue("indT24")

  function showTree(data, title) {
    PopupStore.open(POPUPS_IDS.TREES, {title, data})
  }

  const deployed = PopupStore.isOpened(POPUPS_IDS.JAUGES)

  return (
    <div className="ui-jauge">

      { deployed &&
      <div className="links">
        <div className="weight weight1">{Math.floor( ParametersPool.getDef("indT42") * 100)}%</div>
        <div className="weight weight2">{Math.floor( ParametersPool.getDef("indT24") * 100)}%</div>
        <div className="weight weight3">{Math.floor( ParametersPool.getDef("indT37") * 100)}%</div>
      </div>}

      <RainbowGauge
      small={false}
      value={sustainability}
      title={store.t("sustainability")}
      onClick={() => PopupStore.toggle(POPUPS_IDS.JAUGES)} />

      { deployed &&
      <>
        <div className="top-left">
          <RainbowGauge
            small={true}
            value={eco}
            data={store.indicatorsTrees.eco}
            onClick={showTree}
            title={store.t("economic")} />
        </div>

        <div className="top-center">
          <RainbowGauge
            small={true}
            value={environmental}
            data={store.indicatorsTrees.env}
            onClick={showTree}
            title={store.t("environment")} />
        </div>

        <div className="top-right">
          <RainbowGauge
            small={true}
            value={social}
            data={store.indicatorsTrees.soc}
            onClick={showTree}
            title={store.t("social")} />
        </div>
      </>}
    </div>
  )
}

export default observer(UIJauge)
